import Daun1 from '../../../assets/images/s6_daun_1.png'
import Daun2 from '../../../assets/images/s6_daun_2.png'
import Daun3 from '../../../assets/images/s6_daun_3.png'
import Image1 from '../../../assets/images/s6_image_1.png'
import Image2 from '../../../assets/images/s6_image_2.png'

const Section6 = () => {
    return (
        <div id='misi' className="w-full h-screen grid grid-cols-1 md:grid-cols-2">
            <div className='w-full md:h-screen flex items-center justify-center relative'>
                <div className='relative'>
                    <img src={Image1} alt="Kebun Jitu" className="max-w-[250px] md:max-w-[350px] object-contain z-10 -ml-10" loading='lazy'/>
                    <img src={Image2} alt="Kebun Jitu" className="max-w-[100px] md:max-w-[150px] object-contain z-10 absolute right-0 -bottom-10" loading='lazy'/>
                </div>
                <img src={Daun1} alt="Kebun Jitu" className="max-w-[100px] object-contain z-10 absolute bottom-5 left-0 md:left-10" loading='lazy'/>
            </div>
            <div className="w-full flex flex-col items-start justify-center gap-3 relative px-5 md:px-0 md:pr-10 md:pt-36">
                <img src={Daun2} alt="Kebun Jitu" className="max-w-[100px] object-contain z-10 self-end" loading='lazy'/>
                <h1 className="text-3xl md:text-5xl font-bold text-custom-green">Misi Kami</h1>
                <p className="text-justify pb-5">
                    {/* To help horticulture farmers thrive by making precision agriculture simple and accessible */}
                    Misi kami bukan hanya tentang teknologi, tetapi tentang menciptakan harapan baru bagi petani untuk masa depan yang lebih cerah. Dengan KebunJitu, kami menghubungkan teknologi dengan kebutuhan petani untuk mendukung pertanian yang lebih produktif dan berkelanjutan.
                </p>
                <div className="bg-black rounded-full w-full text-white">
                    <div className="w-full rounded-full flex flex-col md:flex-row items-center justify-between bg-gradient-to-tr from-custom-green to-custom-green/30 px-3 py-2 gap-3">
                        <p>The Mission of Kebun Jitu</p>
                        <button type='button' className=' flex items-center justify-center gap-2 font-semibold bg-custom-orange px-5 py-1 rounded-full capitalize'>
                            Pelajari lebih lanjut
                        </button>
                    </div>
                </div>
                <img src={Daun3} alt="Kebun Jitu" className="max-w-[150px] md:max-w-[250px] object-contain z-10 self-center md:self-end" loading='lazy'/>
            </div>
        </div>
    )
}

export default Section6